import BlockText from "../block-content/block-text";
import styled from "styled-components";
import tw from "twin.macro";
import Image from "gatsby-plugin-sanity-image";
const BlockQuote = styled.blockquote`
  ${tw`font-mono`}
  p {
    ${tw`text-xl md:text-2xl leading-snug`}
  }
`;
const Title = styled.div`
  p {
    ${tw`text-sm opacity-75`}
  }
`;

const TestimonialImage = styled.div`
  ${tw`bg-yellow-200 overflow-hidden`}
  width: 100%;
  align-self: stretch;
  image {
    width: 100%;
  }

  @media (max-width: 639px) {
    height: 600px;
  }
  @media (max-width: 539px) {
    height: 500px;
  }
  @media (max-width: 439px) {
    height: 400px;
  }

  @media (min-width: 640px) {
    width: 256px;
  }
`;

const TestimonialContent = styled.div`
  ${tw`p-6 md:px-8`}
  @media (min-width: 640px) {
    width: calc(100% - 256px);
  }
`;

const TestimonialBlock = (props) => {
  const testimonialBlock = props.props ?? props.pageBlock;
  testimonialBlock.testimonial = props.props?.testimonial ?? props.pageBlock;
  testimonialBlock.testimonial._rawBody =
    testimonialBlock?._rawTestimonialBody ??
    testimonialBlock.testimonial._rawBody;

  return (
    <section
      key={testimonialBlock._key}
      className="py-8 md:py-16 px-4 bg-tile-pattern"
    >
      <div className="max-w-5xl mx-auto bg-blue-500 text-white shadow-2xl">
        <div className="flex sm:flex-wrap flex-wrap-reverse sm:items-center">
          {testimonialBlock.testimonial?.photo &&
            testimonialBlock.testimonial.photo?.asset && (
              <TestimonialImage>
                <Image
                  style={{ width: "100%" }}
                  asset={testimonialBlock.testimonial.photo.asset}
                  hotspot={testimonialBlock.testimonial.photo.hotspot}
                  crop={testimonialBlock.testimonial.photo.crop}
                  width={256}
                  height={384}
                  className="h-full object-cover align-top"
                  alt={
                    testimonialBlock.testimonial.photo.alt ||
                    `${testimonialBlock.testimonial.student.person.firstName} ${testimonialBlock.testimonial.student.person.lastName}`
                  }
                />
              </TestimonialImage>
            )}
          <TestimonialContent>
            {testimonialBlock.testimonial &&
              testimonialBlock.testimonial.student && (
                <BlockQuote>
                  <BlockText blocks={testimonialBlock.testimonial._rawBody} />
                  <footer className="border-l-4 font-sans border-yellow-500 pl-4 mt-6">
                    <h3 className="font-bold text-lg">
                      {testimonialBlock.testimonial.student.person.firstName}
                      {` `}
                      {testimonialBlock.testimonial.student.person.lastName}
                      {` `}
                      {
                        testimonialBlock.testimonial.student.person
                          .graduationYear
                      }
                      {` `}
                      {testimonialBlock.testimonial.student.person.postnominal}
                      {/* {`’${testimonialBlock.testimonial.student.person.graduationYear.substr(2, 2)}`} */}
                    </h3>
                    <Title>
                      <BlockText
                        blocks={testimonialBlock.testimonial.student._rawTitle}
                      />
                    </Title>
                  </footer>
                </BlockQuote>
              )}
          </TestimonialContent>
        </div>
      </div>
    </section>
  );
};

export default TestimonialBlock;
